// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__24SgU","col":"styles_col__1QKJs"};